import type * as THREE from 'three'

/**
 * Hit-testing registry.
 *
 * Picking runs through one manual `Raycaster` against a single invisible hitbox
 * per item, not through R3F's event system and not against the item's real
 * meshes. Two reasons: any `stopPropagation()` upstream would silently break
 * mesh events mid-gesture, and picking a chair by its footprint (rather than by
 * hitting an actual 3 cm caster) is what every furniture planner does.
 */
const registry = new Map<string, THREE.Object3D>()

export const ITEM_UID_KEY = 'itemUid'

export function registerItem(uid: string, object: THREE.Object3D | null): void {
  if (!object) {
    registry.delete(uid)
    return
  }
  object.userData[ITEM_UID_KEY] = uid
  registry.set(uid, object)
}

export function unregisterItem(uid: string): void {
  registry.delete(uid)
}

export function hitTargets(): THREE.Object3D[] {
  return [...registry.values()]
}

export function uidForObject(object: THREE.Object3D | null): string | null {
  let current: THREE.Object3D | null = object
  while (current) {
    const uid = current.userData[ITEM_UID_KEY] as string | undefined
    if (uid) return uid
    current = current.parent
  }
  return null
}
